function hasSomeParentTheClass(element, classname, initial) {
  if (!initial && element?.className?.split(' ').indexOf(classname) >= 0) return true;
  return element.parentNode && hasSomeParentTheClass(element.parentNode, classname, false);
}

export default hasSomeParentTheClass;
